/**
 * common路由
 */
import { RouteConfig } from 'vue-router'

import { WhiteBarStyle } from '$utils/bar-style'

const routers: RouteConfig[] = []
routers.push(
  {
    path: '/',
    meta: {
      title: '随手记账 轻松出游',
      pullRefresh: true,
      barStyle: WhiteBarStyle,
      customerService: false,
    },
    component: () => import(/* webpackChunkName: "_bury_" */ '$views/index.vue')
  },
)

export default routers
